export default "__VITE_ASSET__D5t1JV7F__"